import React from 'react';

import classNames from 'classnames';

import Addon from './Addon';
import RightAddon from './RightAddon';
import { domOnlyProps } from '../../helpers/helpers';

class PureInput extends React.Component {
    constructor(props) {
        super(props);
        const { formatter } = props;
        const value = formatter ? formatter(props.value) : props.value;

        this.state = {
            value
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { formatter } = this.props;
        if (this.props.value !== nextProps.value) {
            let value = formatter
                ? formatter(nextProps.value)
                : nextProps.value;
            this.setState({
                value
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.value !== nextState.value || this.props !== nextProps;
    }

    onBlur = (e) => {
        const { parser, onBlur, whenBlur } = this.props;
        // TODO: change to const {value} = this.state;
        const value = e.target.value;

        if (onBlur) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            Promise.resolve().then(() =>
                parser ? onBlur(parser(value)) : onBlur(value)
            );
        }
        if (whenBlur) {
            whenBlur(e);
        }
    };

    onFocus = (e) => {
        const { onFocus, whenFocus } = this.props;
        // TODO: change to const {value} = this.state;
        const value = e.target.value;

        if (onFocus) {
            onFocus(value);
        }
        if (whenFocus) {
            whenFocus(e);
        }
    };

    onChange = (e) => {
        const { formatter, handleChange } = this.props;
        const value = formatter ? formatter(e.target.value) : e.target.value;
        if (handleChange) {
            handleChange(e, formatter);
        }
        this.setState({ value });
    };

    onKeyPress = (e) => {
        const { parser, onChange } = this.props;
        if (e.which === 13 && onChange) {
            let value = this.state.value;
            parser ? onChange(parser(value)) : onChange(value);
        }
    };

    render() {
        const rightBorderClass = {
            'iw-no-right-border': this.props.noRightBorder
        };
        let newProps = {
            ...this.props,
            onBlur: this.onBlur,
            onChange: this.onChange,
            value: this.state.value,
            onKeyPress: this.onKeyPress,
            onFocus: this.onFocus
        };

        return (
            <input
                autoComplete="off"
                {...domOnlyProps(newProps)}
                className={classNames(rightBorderClass, 'form-control')}
                data-testid={`${this.props.name}-input`}
            />
        );
    }
}

PureInput.Addon = Addon;
PureInput.RightAddon = RightAddon;

export default PureInput;
